import { css } from 'reakit/styled';
import { palette, theme } from 'styled-tools';
import 'styled-selector';
import selector from '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import Label from 'reakit/Label';
import 'reakit/Input';
import { a as HiddenInput } from '../chunk-2cd0d082.js';

var RadioIcon = styled(Box).withConfig({
  displayName: "styled__RadioIcon",
  componentId: "sc-1viz9if-0"
})(["border:1px solid #bdbdbd;background-color:white;box-shadow:inset 0px 1px 2px #e5e5e5;border-radius:100%;height:1em;position:relative;width:1em;&{", ";}&{", ";}"], function (props) {
  return props.state && css(["border-color:", ";box-shadow:", " 0px 0px 0px 1px !important;"], function (props) {
    return palette("" + props.state)(props);
  }, function (props) {
    return palette("" + props.state)(props);
  });
}, theme('fannypack.Radio.base'));
var HiddenRadio = HiddenInput({
  Icon: RadioIcon,
  checkedIconCss: css(["background:", ";border-radius:50%;content:'';height:0.5em;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:0.5em;"], palette('primary')),
  disabledCheckedIconCss: css(["background:", ";"], palette('gray300')),
  themePrefix: 'Radio'
});
var Radio = styled(Label).withConfig({
  displayName: "styled__Radio",
  componentId: "sc-1viz9if-1"
})(["display:flex;align-items:center;&{", ";}"], theme('fannypack.Radio.label'));
var horizontalProperties = css(["display:flex;& ", ":not(:last-child){margin-right:1rem;margin-bottom:unset;}&{", ";}"], selector(Radio), theme('fannypack.RadioGroup.horizontal'));
var RadioGroup = styled(Box).withConfig({
  displayName: "styled__RadioGroup",
  componentId: "sc-1viz9if-2"
})(["& ", ":not(:last-child){margin-bottom:0.5rem;}&{", ";}"], selector(Radio), function (props) {
  return props.isHorizontal && horizontalProperties;
});

export default Radio;
export { HiddenRadio, Radio, RadioGroup, RadioIcon };
